export default __webpack_public_path__ + "proximanova-thinit-webfont.woff2";